var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBuildings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.83 1.67H7.5c-.92 0-1.67.74-1.67 1.66V8l-3.92 3.9a.83.83 0 0 0 .59 1.42v4.17a.83.83 0 0 0 .83.83h13.34a.83.83 0 0 0 .83-.83V3.33c0-.92-.75-1.66-1.67-1.66Zm-6.66 15h-5V12l2.5-2.5 2.5 2.5v4.66Zm6.66 0h-5v-3.34a.83.83 0 0 0 .6-1.42L7.5 8V3.33h8.33v13.34Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17 5h1.66v1.67H9.17V5Zm3.33 0h1.67v1.67H12.5V5Zm0 3.36h1.67V10H12.5V8.36Zm0 3.3h1.67v1.67H12.5v-1.66Zm-6.67.84H7.5v1.67H5.83V12.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBuildings);
export default ForwardRef;